import React, { useEffect, useState } from 'react'
import { adminGetUserNameApi } from '../../../api/admin/user'
import { Link, useParams } from 'react-router-dom'
import { swalErrorAlert } from '../../../utils/swal/swal'
import { useForm } from 'react-hook-form'
import { adminGetCounselInfoApi } from '../../../api/admin/counsel'
import AdminSavedFileList from '../../../components/admin/common/AdminSavedFileList'

const AdminCounselRead = () => {
    const { userId, counselId } = useParams()
    const [userName, setUserName] = useState('')

    useEffect(() => {
        getUserName(userId)
    }, [])

    const getUserName = async (userId) => {
        if (!userId) {
            setUserName('')
            return
        }

        try {
            const response = await adminGetUserNameApi(userId)

            if (response.data?.code === 200) {
                const userName = response.data?.resData?.user_name
                setUserName(userName)
            } else {
                setUserName('')
            }
            return

        } catch (error) {
            setUserName('')
            swalErrorAlert()
            return
        }
    }

    return (
        <div className="container-fluid">
            {/* Page Heading */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0">상담내용 관리</h1>
            </div>

            {/* Content Row */}
            <div className="card shadow mb-4">

                <div className="card-header py-3">
                    <div className='d-flex justify-content-between align-items-center'>
                        <h6 className="m-0 font-weight-bold">
                            {userName}학생 상담내용
                        </h6>
                    </div>
                </div>

                <div className="card-body" style={{ height: "calc(100vh - 385px)", overflow: "auto" }}>
                    <div className="">
                        <CounselReadForm counselId={counselId} />
                    </div>
                </div>

                <div className='card-footer'>
                    <div className='text-end'>
                        <Link to={`/hy-admin/counsel/list/${userId}`} className='btn btn-secondary'>목록으로</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

const CounselReadForm = ({ counselId }) => {

    /* React Hook Form */
    const { reset, getValues } = useForm()

    const [counselInfo, setCounselInfo] = useState(null)
    const [savedFiles, setSavedFiles] = useState([])
    const [writeName, setWriterName] = useState('')

    useEffect(() => {
        getCounselInfo(counselId)
    }, [counselId])

    useEffect(() => {
        reset(counselInfo)
    }, [counselInfo])

    const getCounselInfo = async (counselId) => {
        if (!counselId) {
            setCounselInfo(null)
            return
        }

        try {
            const response = await adminGetCounselInfoApi(counselId)
            if (response.status === 200) {
                const jsonData = response.data?.resData?.json_data ? response.data?.resData?.json_data : null
                const savedFiles = response.data?.resData?.files ? response.data?.resData?.files : []
                const writerName = response.data?.resData?.writer_name ? response.data?.resData?.writer_name : ''

                setCounselInfo(jsonData)
                setSavedFiles(savedFiles)
                setWriterName(writerName)
            }
            return

        } catch (error) {
            console.log(error);
            setCounselInfo(null)
            setSavedFiles([])

            swalErrorAlert()
            return
        }
    }


    return (
        <table className='table table-bordered align-middle'>
            <colgroup>
                <col width={"100px"} />
                <col width={"auto"} />
            </colgroup>
            <tbody>
                <tr>
                    <td className='bg-secondary text-light'>제목</td>
                    <td>
                        <div>{getValues('title')}</div>
                    </td>
                </tr>
                <tr>
                    <td className='bg-secondary text-light'>상담일</td>
                    <td>
                        <div>{getValues('date')}</div>
                    </td>
                </tr>
                <tr>
                    <td className='bg-secondary text-light'>작성자</td>
                    <td>
                        <div>{writeName}</div>
                    </td>
                </tr>
                <tr>
                    <td className='bg-secondary text-light'>내용</td>
                    <td>
                        <textarea
                            style={{ background: "#fff" }}
                            className='form-control'
                            rows={26}
                            readOnly
                            disabled
                            value={getValues('content')}
                        />
                    </td>
                </tr>
                <tr>
                    <td className='bg-secondary text-light'>첨부파일</td>
                    <td>
                        <div>
                            <AdminSavedFileList
                                savedFiles={savedFiles}
                                fileFolderName={'counsel'}
                                isEdit={false}
                            />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    )

}

export default AdminCounselRead